import React, { useCallback, useEffect } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import { Redirect, Route, Switch } from "react-router-dom";
import ProductContainer from "../containers/ProductContainer";
import UserContainer from "../containers/UserContainer";
import UsageContainer from "../containers/UsageContainer";
import ActivityContainer from "../containers/ActivityContainer";
import CurrentUserError from "../components/user/CurrentUserError";
import ScreenLoading from "../components/general/ScreenLoading";
import { REQUESTED_CURRENT_USER } from "../redux/actions/userAction";

export default () => {
  const mapState = useCallback(
    (state) => ({
      currentUser: state.userState.currentUser,
      isFetchingCurrentUser: state.userState.isFetchingCurrentUser,
      fetchingCurrentUserFailed: state.userState.fetchingCurrentUserFailed,
      fetchingCurrentUserError: state.userState.fetchingCurrentUserError,
    }),
    []
  );

  const {
    currentUser,
    isFetchingCurrentUser,
    fetchingCurrentUserFailed,
    fetchingCurrentUserError,
  } = useMappedState(mapState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!currentUser && !isFetchingCurrentUser) {
      dispatch({
        type: REQUESTED_CURRENT_USER,
        payload: {},
      });
    }
  }, [dispatch, currentUser, isFetchingCurrentUser]);

  function renderBody() {
    if (!currentUser) {
      // specifically when the error is 'jwt expired'
      // instead of showing an error msg lable
      // keep loading spinners while keycloak refreshs the token
      if (
        !fetchingCurrentUserFailed ||
        (fetchingCurrentUserError &&
          fetchingCurrentUserError.message === "jwt expired")
      ) {
        return <ScreenLoading />;
      } else {
        return <CurrentUserError error={fetchingCurrentUserError} />;
      }
    } else {
      return (
        <Switch>
          <Redirect exact path="/" to="/product/list" />
          <Redirect exact path="/product" to="/product/list" />
          <Redirect exact path="/user" to="/user/list" />
          <Redirect exact path="/activity" to="/activity/list" />
          <Route path="/product" component={ProductContainer} />
          <Route path="/user" component={UserContainer} />
          <Route path="/activity" component={ActivityContainer} />
          <Route path="/usage" component={UsageContainer} />
        </Switch>
      );
    }
  }

  return renderBody();
};
